import { HttpClient } from "@angular/common/http";
import { NGXLogger } from "ngx-logger";
import { Injectable } from "@angular/core";

@Injectable()
export class AdminDashboardService {

  constructor(private http: HttpClient,
    private logger: NGXLogger) { }

  getAdminTxnsDashboardReportView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/txns-dashboard-report/view', viewAdminDashboard, { observe: 'response' });
  }

  getAdminTxnsDashboardGraphDataView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/txns-dashboard-graph-data/view', viewAdminDashboard, { observe: 'response' });
  }

  getAdminPaymentKeyperFormanceIndicatorView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/payment-keyperformance-indicator/view', viewAdminDashboard, { observe: 'response' });
  }

  getAdminTxnsStaticsView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/txns-statics/view', viewAdminDashboard, { observe: 'response' });
  }

  getAdminTxnsRegCitizenView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/txns-reg-citizen/view', viewAdminDashboard, { observe: 'response' });
  }

  getAdminTxnsRegBillerView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/txns-reg-biller/view', viewAdminDashboard, { observe: 'response' });
  }

  getAdminBillerPerformanceView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/biller-performance/view', viewAdminDashboard, { observe: 'response' });
  }

  getAssistedPerformanceView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from Assisted Dashboard.....");
    return this.http.post('/honcho/api/dashboard/admin/syndicate-txns-amount/view', viewAdminDashboard, { observe: 'response' });
  }

  getAdminTopRecordsView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/top-records/view', viewAdminDashboard, { observe: 'response' });
  }

  getAdminPaymentSuccessRateView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/payment-success-rate/view', viewAdminDashboard, { observe: 'response' });
  }

  getAdminPaymentTxnsAmountView(viewAdminDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/payment-txns-amount/view', viewAdminDashboard, { observe: 'response' });
  }
  getNumberOfVisitor(viewAdminDashboard): any {
    //this.logger.debug("calling get api from Visitors....." +JSON.stringify(viewAdminDashboard));
    return this.http.post('/honcho/api/dashboard/admin/visitor-graph-data/view', viewAdminDashboard, { observe: 'response' });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboards/admin-dashboard/admin-dashboard.service.ts